import React from 'react';
import { VerticallyCenteredText } from 'src/shared/design-system/VerticallyCenteredText';
import styled, { css } from 'styled-components';
import { ifProp } from 'web-common/src/shared/styled-utils/ifProp';
import { Colors, Font, Spacing } from 'web-common/src/shared/styles';

const Card = styled.div<{ onClick?: () => void }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  border-radius: 8px;
  border: 1px solid ${Colors.GRAY_LITE_20};
  background: ${Colors.WHITE};

  padding: ${Spacing.SINGLE};

  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.08);
  ${ifProp(
    'onClick',
    css`
      cursor: pointer;
      transition: box-shadow 0.2s ease-in-out;

      &:hover {
        box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.16);
      }
    `,
    css`
      cursor: default;
    `
  )};
`;

const Headline = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${Spacing.HALF};
  color: ${Colors.GRAY_DARK_30};
  font-size: ${Font.Size.S};
  font-family: ${Font.Family.SANS};
  font-weight: ${Font.Weight.BOLD};
  line-height: 130%;
`;

const Description = styled.span<{ underline?: boolean }>`
  color: ${Colors.GRAY_DARK_15};
  font-size: ${Font.Size.XXS};
  font-family: ${Font.Family.SANS};
  font-weight: ${Font.Weight.MEDIUM};
  line-height: 120%;
  text-decoration-line: ${ifProp('underline', 'underline', 'unset')};
  width: max-content;
`;

interface IProps {
  className?: string;
  headline: string;
  icon?: React.ReactNode;
  description: string;
  onClick?: () => void;
}

export const DescriptionCard: React.FC<IProps> = ({ className, headline, icon, description, onClick }) => (
  <Card className={className} onClick={onClick}>
    <Headline className='mb-1'>
      {icon}
      <VerticallyCenteredText>{headline}</VerticallyCenteredText>
    </Headline>
    <Description underline={!!onClick}>{description}</Description>
  </Card>
);
